import i18next from 'i18next';

i18next.addResources('es_CL', 'Errors', {
  delivery_fee_types:
    'Para cambiar el modo de delivery debe configurar el tipo de tarifa correspondiente en el Command Center',
  not_authorized: 'No estás autorizado para realizar esta acción'
});

i18next.addResources('es_CR', 'Errors', {
  delivery_fee_types:
    'Para cambiar el modo de delivery debe configurar el tipo de tarifa correspondiente en el Command Center',
  not_authorized: 'No estás autorizado para realizar esta acción'
});
